<template>
  <v-content class="digital_ticket" v-if="item != null">

    <h1 class="mt-8 text-center fontsize18 font-weight-bold">決済情報入力</h1>

    <div class="mb-5" style="width:30%; margin:0 auto;">
      <v-divider class="my-2 border_maincolor"></v-divider>
    </div>

    <div class="body-2 py-2 px-4 mb-1 font-weight-bold" style="background-color: #E4E4E4; color: #333333;">
      お客様情報 <v-chip x-small class="ml-2 maincolor-bg">必須</v-chip>
    </div>

    <ValidationObserver ref="observer">
    <div class="pa-4">
      <h3 class="fontsize13 font-weight-bold" style="color:#9D9D9D;">お名前</h3>
      <ValidationProvider v-slot="{ errors }" name="お名前" rules="required|max:255">
      <v-text-field class="pt-0 mb-4 subtitle-2" v-model="name" placeholder="お名前を入力してください" single-line :error-messages="errors" required></v-text-field>
      </ValidationProvider>

      <h3 class="fontsize13 font-weight-bold" style="color:#9D9D9D;">メールアドレス</h3>
      <ValidationProvider v-slot="{ errors }" name="メールアドレス" rules="required|email|max:255">
      <v-text-field class="pt-0 mb-4 subtitle-2" v-model="mail" placeholder="メールアドレスを入力してください" single-line type="email" :error-messages="errors" required></v-text-field>
      </ValidationProvider>

      <h3 class="fontsize13 font-weight-bold" style="color:#9D9D9D;">電話番号(ハイフンなし)</h3>
      <ValidationProvider v-slot="{ errors }" name="電話番号" :rules="{required: true, max: 11,regex: /^(0{1}\d{9,10})$/ }">
      <v-text-field class="pt-0 mb-4 subtitle-2" v-model="tel" placeholder="電話番号を入力してください" single-line type="tel" :error-messages="errors" required></v-text-field>
      </ValidationProvider>
    </div>
    </ValidationObserver>

    <div class="body-2 py-2 px-4 mb-1 font-weight-bold" style="background-color: #E4E4E4; color: #333333;">
      クレジットカード情報 <v-chip x-small class="ml-2 maincolor-bg">必須</v-chip>
    </div>

    <div class="pa-4 mb-3">
      <p v-if="item.jcb_flg == 1" class="fontsize13 mb-2">各種クレジットカード（Visa、Master Card、Discover、American Express、Diners Club、JCB）でお支払いいただけます。</p>
      <p v-else class="fontsize13 mb-2">各種クレジットカード（Visa、Master Card、Discover、American Express、Diners Club）でお支払いいただけます。</p>
      <v-row class="cardimg" no-gutters justify="start" align-content="start">
        <v-col>
          <img src="@/assets/digital_ticket/visa@2x.png" width="53">
        </v-col>
        <v-col>
          <img src="@/assets/digital_ticket/mastercard@2x.png" width="53">
        </v-col>
        <v-col>
          <img src="@/assets/digital_ticket/discover@2x.png" width="53">
        </v-col>
        <v-col>
          <img src="@/assets/digital_ticket/american-express@2x.png" width="53">
        </v-col>
        <v-col>
          <img src="@/assets/digital_ticket/dinners-club@2x.png" width="53">
        </v-col>
        <v-col v-if="item.jcb_flg == 1">
          <img src="@/assets/digital_ticket/jcb@2x.png" width="53">
        </v-col>
      </v-row>

      <dl v-if="stripeForm" class="dl-ticket-kessai">
          <dt>カード番号</dt>
          <dd><div id="card-errors" ref="cardErrors" class="error-text" role="alert"></div></dd>
          <dd class="StripeElement-Input" id="card-number-element"></dd>
          <dt >有効期限</dt>
          <dd ><div id="cardExpiry-errors" class="error-text" role="alert"></div></dd>
          <dd  class="StripeElement-Input" id="card-expiry-element"></dd>
          <dt >セキュリティコード</dt>
          <dd ><div id="cardCvc-errors" class="error-text" role="alert"></div></dd>
          <dd  class="StripeElement-Input" id="card-cvc-element"></dd>
      </dl>

      <dl v-if="stripeInfo" class="dl-ticket-kessai">
          <dt>カード番号</dt>
          <dd><div class="error-text" role="alert"></div></dd>
          <dd v-if="stripe_customer_info != null" class="StripeElement-Input" id="card-number-display">**** **** **** {{ cardNumberLast4 }}</dd>
          <div class="pa-3 text-center mb-5">
            <v-btn v-if="stripe_customer_info != null" rounded depressed class="maincolor-bg default_button w80 py-5" @click="stripInput">決済情報を入力する</v-btn>
          </div>
      </dl>

      <p v-if="stripeForm" class="caption mb-8" @click="securitycodeDialog = true">
        <v-icon small color="black">fas fa-info-circle</v-icon> セキュリティコードについて
      </p>

      <p class="kakunin-kiyaku">
        <v-checkbox v-model="kiyaku" class="fontsize11 ma-0 pa-0">
          <template v-slot:label>
            <div class="fontsize11">
              <!-- 20201208 NEW_DEV-733 A36-No.21 cyber 李 start -->
              <span style="color: #1976D3; text-decoration: underline;" @click="ruleDialog = true">利用規約およびプライバシーポリシー</span>に同意の上、{{payText}}する
              <!-- 20201208 NEW_DEV-733 A36-No.21 cyber 李 end -->
            </div>
          </template>
        </v-checkbox>
      </p>

      <p v-if="stripeForm" class="kakunin-kiyaku">
        <v-checkbox v-model="keepCard" :label="`決済情報を登録して保存する`" class="checkfont fontsize11 ma-0 pa-0"></v-checkbox>
      </p>

      <div class="px-4 text-center">
        <v-btn rounded class="maincolor-bg default_button2 title" @click="entryConfirm = true" :disabled="btnDisabledFlg" v-if="item.limit_type == 2">エントリーする</v-btn>
        <v-btn rounded class="maincolor-bg default_button2 title" @click="pay" :disabled="btnDisabledFlg" v-else>購入する</v-btn>
        <v-btn rounded depressed class="graybtn default_button w70 mt-5 mb-12" @click="$router.go(-1)">キャンセルする</v-btn>
      </div>

    </div>

    <!-- 20201208 NEW_DEV-733 A36-No.21 cyber 李 start -->
    <!-- 利用規約およびプライバシーポリシーダイアログ -->
    <v-dialog v-model="ruleDialog" height="522">
      <v-card class="pa-4">
        <Rule :dialog_flg="true"></Rule>
        <div class="text-center">
          <v-btn rounded depressed class="caption font-weight-black mb-10 w80" style="background-color:#EFEFEF;" @click="ruleDialog = false">閉じる</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- 20201208 NEW_DEV-733 A36-No.21 cyber 李 end -->

    <!-- セキュリティコードについてダイアログ -->
    <v-dialog v-model="securitycodeDialog">
      <v-card class="pa-4">

        <h1 class="body-1 mb-4"><v-icon small color="black">fas fa-info-circle</v-icon> セキュリティーコードについて</h1>
        <p class="inner fontsize11">セキュリティーコードとは、クレジットカードの裏面にある右端の番号３桁（American Expressは表面の４桁）の数字です。</p>
        <table style="width: 100%">
        <tbody><tr>
            <td class="card"><img src="@/assets/digital_ticket/creditcard_security1.svg" alt=""></td>
                                <td class="body-2">Visa<br>
                Master Card
            </td>
                          </tr>
        <tr>
            <td class="card"><img src="@/assets/digital_ticket/creditcard_security2.svg" alt=""></td>
            <td class="body-2">American Express</td>
        </tr>
        </tbody></table>


        <div class="text-center mt-10">
          <v-btn rounded depressed class="graybtn caption font-weight-black mb-10 w80" style="background-color:#EFEFEF;" @click="securitycodeDialog = false">閉じる</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- エントリー確認ダイアログ -->
    <v-dialog v-model="entryConfirm">
      <v-card class="pa-4">

        <h3 class="maincolor text-center entry_dialogue_title">エントリー時の注意事項</h3>
        <p class="entry_dialogue_text">・当選した場合、チケットはチケット一覧の「購入済みチケット」内に移動します。<br>・落選した場合、チケット一覧からチケットが自動で削除されます。<br>・当選時に自動で決済が行われます。</p>
        <div class="px-4 text-center">
          <v-btn rounded class="maincolor-bg default_button2 title" @click="pay">エントリーする</v-btn>
          <v-btn rounded depressed class="graybtn default_button w70 mt-5 mb-12" @click="entryConfirm = false">キャンセルする</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-content>

</template>

<script>
import {loadStripe} from '@stripe/stripe-js';
import { required, email, regex, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import Rule from "@/views/info/rule";
import Vue from 'vue';
import VueMeta from 'vue-meta';
Vue.use(VueMeta)
import { getStripeErrorMessage } from "@/utils/stripe-errors";

setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('email', {
  ...email,
  message: '正しいメールアドレス形式ではありません',
})

extend('max', {
  ...max,
  message: '{_field_} は{length}文字以内で入力してください。',
})

extend('regex', {
  ...regex,
  message: '{_field_} は正しい形式で入力してください。',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Rule,
  },
  data() {
    return {
      init: [],
      page: 1,
      result: null,
      data: null,
      model: null,
      maincolor: this.storageGet('color_code'),
      item: null,
      user_info: null,
      stripe_customer_id: null,
      stripe_customer_info: null,
      stripeForm: false,
      stripeInfo: false,
      paymode: 2,
      privacycheck: false,
      securitycodeDialog: false,
      ruleDialog: false,
      isApplePay: 0,
      stripe: "",
      card: null,
      loading: false,
      btnDisabledFlg: false,
      payment: null,
      name: null,
      tel: null,
      mail: null,
      keepCard: false,
      kiyaku: false,
      payText: '購入',
      payText2: '購入',
      entryConfirm: false,
      customer_shop_id: null,
      newStripeCustomerId: null,
      defaultPaymentMethodId: null,
      clientSecret: null,
      stripe_id: null,
      cardNumberLast4: '',
      ticketType: '',
    };
  },
  metaInfo: {
    meta: [
      { 'http-equiv': 'Cache-Control', content: 'no-cache' },
      { 'http-equiv': 'Pragma', content: 'no-cache' },
      { 'http-equiv': 'Expires', content: '0' }
    ]
  },

  async mounted () {

    // native側から叩けるようグローバル化したい関数を、下記に登録
    window.applePaySetupButton = () => { this.applePaySetupButton(); }
    window.applePayBuyButton = () => { this.applePayBuyButton(); }
    window.completeApplePay = (result) => { this.completeApplePay(result); }

  },

  methods: {

    async stripInput () {
      this.stripeForm = true;
      this.stripeInfo = false;

      // Stripe準備
      await this.makeStripe(this.item);
      await this.makeStripeForm()
    },

    async getPaymentMethod() {
      if (!this.stripeForm) return this.defaultPaymentMethodId;
      const result = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.card,
      });
      if (result.error) {
        console.error("[Stripe] createPaymentMethodエラー : ", result.error);

        this.loading = false
        this.btnDisabledFlg = false

        // Inform the user if there was an error.
        var errorElement = document.getElementById('cardTotal-errors');
        var carDisplayError = document.getElementById('card-errors');
        if (carDisplayError.innerHTML != result.error.message) {
          errorElement.textContent = result.error.message;
        }

        return false;
      }

      return result.paymentMethod.id;
    },

    async updateStripeCustomer(usePaymentMethodId) {
      if (!this.stripeForm) return true;

      const updateCustomerParams = {
        uid: this.user_info.uid,
        name: this.name,
        phone: this.tel,
        email: this.mail,
        payment_method_id: usePaymentMethodId,
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,
      };
      updateCustomerParams.stripe_customer_id = this.stripe_customer_id;

      const updateCustomerResponse = await this.apiCall('stripe/customer', updateCustomerParams, 'post');
      if (!updateCustomerResponse) return false;
      if (!updateCustomerResponse.stripe_customer_id) {
        this.callDialog('顧客情報更新エラー', '顧客情報更新でエラーとなりました。', 3);
        return false;
      }

      this.stripe_customer_id = updateCustomerResponse.stripe_customer_id;

      return true;
    },

    async updateUserInfo(userParams) {
      const userUpdateResponse = await this.apiCall("/user/info", userParams, 'post');
      return !!userUpdateResponse; // 成功すれば true を返す
    },

    async createTemporaryPurchase() {
      // ストライプ顧客情報登録後 仮購入
      // UPLINK DB 購入履歴用パラメータ
      const historyParams = {
        t_paid_ticket_id: this.item.id,
        mail: this.mail,
        name: this.name,
        tel: this.tel,
        stripe_customer_id: this.stripe_customer_id,
        stripe_token: '',
        stripe_status: 0,
        settlement_flg: false,        // 決済トークンチェックフラグ
        stripe_id: this.stripe_id,
        payment_shop_id: String(this.customer_shop_id),
      };

      const pay_info = await this.apiCall('stripe/digitalticket', historyParams, 'post', 0, this.payText2 + '事前処理エラー');
      if (!pay_info || pay_info.status != 100) {
        // 二重アラートになるためコメントアウト
        //this.callDialog('決済事前処理エラー', '決済処理の事前処理でエラーとなりました。', 3);
        return false
      }
      return pay_info;
    },

    async processConfirm(usePaymentMethodId) {
      const options = {
        payment_method: usePaymentMethodId,
        return_url:
          process.env.VUE_APP_HOST_NAME === "localhost"
            ? `http://${process.env.VUE_APP_HOST_NAME}:9003/sp/digital_ticket/result?type=${this.ticketType}&ticket_id=${this.item.id}&shop_id=${this.item.shop_id}&customer_shop_id=${this.customer_shop_id}`
            : `https://${process.env.VUE_APP_HOST_NAME}/sp/digital_ticket/result?type=${this.ticketType}&ticket_id=${this.item.id}&shop_id=${this.item.shop_id}&customer_shop_id=${this.customer_shop_id}`,
      };

      if (this.ticketType === 'subscription') options.setup_future_usage = 'off_session';

      let confirmError, intent;
      if (this.ticketType === 'lottery') {
        ({ error: confirmError, setupIntent: intent } = await this.stripe.confirmCardSetup(this.clientSecret, options, { handleActions: false }));
      } else {
        ({ error: confirmError, paymentIntent: intent } = await this.stripe.confirmCardPayment(this.clientSecret, options, { handleActions: false }));
      }

      if (confirmError) {
        console.error('[Stripe] Stripe error 決済エラー : ', confirmError);

        this.loading = false
        this.btnDisabledFlg = false

        const errorMessage = getStripeErrorMessage(confirmError);
        this.callDialog(this.payText2 + 'エラー', errorMessage, 3);
        return false;
      }

      return intent;
    },

    handleConfirmResult(intent) {
      if (intent.status === 'succeeded') {
        // 結果表示画面に遷移
        this.routerBindToResult(intent);
        return;
      }

      if (intent.status === 'requires_action') {
        if (intent.next_action?.type === 'redirect_to_url') {
          window.location.href = intent.next_action.redirect_to_url.url;
          return;
        } else {
          this.routerBindToResult(intent);
          return;
        }
      }

      this.routerBindToResult(intent);
      return;
    },

    async pay () {
      this.$refs.observer.validate().then(async () => {
        if (this.btnDisabledFlg) return
        if (this.kiyaku == false) {
          alert("利用規約およびプライバシーポリシーに同意の上、ご購入ください");
          return
        }

        // スピナー有効化, ボタンdisabled
        this.loading = true
        this.btnDisabledFlg = true
        try {

          // 支払い方法作成
          const usePaymentMethodId = await this.getPaymentMethod();
          if (!usePaymentMethodId) {
            console.error('支払い方法の作成に失敗しました。');
            return false;
          }

          if (this.user_info.stripe_customer_id != null && this.stripe_customer_info != null) {
            // Stripe顧客情報が取得できるユーザー情報のstripe_customer_idはそのまま使用
            this.stripe_customer_id = this.user_info.stripe_customer_id;
          } else {
            //新規作成したstripe_customer_id
            this.stripe_customer_id = this.newStripeCustomerId;
          }

          if (this.defaultPaymentMethodId !== usePaymentMethodId) {
            // Stripe顧客情報更新
            const isStripeCustomerUpdated = await this.updateStripeCustomer(usePaymentMethodId);
            if (!isStripeCustomerUpdated) {
              console.error("Stripe顧客情報の更新に失敗しました。");
              return false;
            }
          }

          // ストライプ顧客情報登録後 仮購入
          const payInfo = await this.createTemporaryPurchase();
          if (payInfo === false) {
            console.error("仮購入処理に失敗しました。");
            return false;
          }

          // ユーザー情報更新
          const userParams = {
            name: this.name,
            mail: this.mail,
            tel: this.tel,
            customer_shop_id: this.customer_shop_id,
          };

          if (this.stripeForm && this.keepCard) {
            userParams['stripe_customer_id'] = this.stripe_customer_id;
          }

          if (this.ticketType === 'lottery') {
            //抽選の場合
            if (userParams['stripe_customer_id']) {
              // ユーザー情報更新
              const isUserUpdated = await this.updateUserInfo(userParams);
              if (!isUserUpdated) {
                console.error("抽選のユーザー情報更新に失敗しました。");
                return false;
              }
            }

          } else {
            // 通常の場合
            if (!userParams['stripe_customer_id']) {
              if (this.keepCard || (!this.keepCard && this.stripe_customer_info != null && !this.stripeForm)) {
                userParams['stripe_customer_id'] = this.stripe_customer_id;
              }
            }

            // ユーザー情報更新
            const isUserUpdated = await this.updateUserInfo(userParams);
            if (!isUserUpdated) {
              console.error("通常のユーザー情報更新に失敗しました。");
              return false;
            }
          }

          // 決済処理
          const intent = await this.processConfirm(usePaymentMethodId);
          if (intent === false) {
            console.error("決済処理に失敗しました。");
            return false;
          }

          this.handleConfirmResult(intent);

        } catch (e) {
          this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
          console.log(e)
        } finally {
          // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
          this.loading = false
          this.btnDisabledFlg = false
        }
      });
    },

    routerBindToResult(intent) {
      const queryParams = {
        type: this.ticketType,
        ticket_id: this.item.id,
        shop_id: this.item.shop_id,
        customer_shop_id: this.customer_shop_id,
      };
      // confirmCardPayment の場合
      if (intent.object === 'payment_intent') {
          queryParams.payment_intent = intent.id;
          queryParams.payment_intent_client_secret = intent.client_secret;
      }
      // confirmCardSetup の場合
      if (intent.object === 'setup_intent') {
        queryParams.setup_intent = intent.id;
        queryParams.setup_intent_client_secret = intent.client_secret;
      }

      this.routerBindTo({
        name: 'digital_result',
        query: queryParams,
      });
    },

    async makeStripe(digital_ticket) {
      const stripeOptions = {};
      if (digital_ticket.stripe_account_id !== null || digital_ticket.stripe_account_id !== '') stripeOptions.stripeAccount = digital_ticket.stripe_account_id;

      this.stripe = await loadStripe(digital_ticket.stripe_public_key, stripeOptions);
    },


    async makeStripeForm() {
      const options = {
        locale: 'ja',
        clientSecret: this.clientSecret,
      };
      const elements = this.stripe.elements(options);
      // const elements = this.stripe.elements({locale: 'ja'})

      var style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      this.card = elements.create('cardNumber', {style: style});
      var cardExpiry = elements.create('cardExpiry', {style: style});
      var cardCvc = elements.create('cardCvc', {style: style});

      this.card.mount('#card-number-element');
      cardExpiry.mount('#card-expiry-element');
      cardCvc.mount('#card-cvc-element');

      //this.card = elements.create("card");
      //this.card.mount("#card-element");

      this.card.addEventListener('change', ({error}) => {
        const displayError = this.$refs.cardErrors
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = '';
        }
      });

      // Handle real-time validation errors from the card Element.
      cardExpiry.addEventListener('change', function(event) {
        var displayError = document.getElementById('cardExpiry-errors');
        var displayTotalError = document.getElementById('cardTotal-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
          displayTotalError.textContent = '';
        }
      });

      // Handle real-time validation errors from the card Element.
      cardCvc.addEventListener('change', function(event) {
        var displayError = document.getElementById('cardCvc-errors');
        var displayTotalError = document.getElementById('cardTotal-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
          displayTotalError.textContent = '';
        }
      });
    },

    async fetchDigitalTicket() {
      // デジタルチケット詳細API
      const digital_ticket_params = { params:{
        'ticket_id': this.init.ticket_id,
      }}

      // デジタルチケット詳細情報取得
      const digital_ticket = await this.apiCall('/digitalticket/detail', digital_ticket_params);
      if (!digital_ticket) return false;

      this.item = digital_ticket;
      this.customer_shop_id = digital_ticket.created_shop_id;

      // 抽選タイプ
      if (digital_ticket.limit_type == 2) {
        this.payText = 'エントリー';
        this.payText2 = 'エントリー';
      }
      return true;
    },

    async fetchUserInfo() {
      const userInfoParams = { params:{ shop_id: this.customer_shop_id }};

      const user_info = await this.apiCall('/user/info', userInfoParams);
      if (!user_info) return false;

      this.user_info = user_info;

      this.name = user_info.name
      this.tel = user_info.tel
      this.mail = user_info.mail
      return true;
    },

    async fetchOrCreateStripeCustomer() {

      if (!this.user_info.stripe_customer_id) {
        //Stripe顧客情報なし
        return await this.createStripeCustomer();
      }

      // Stripe顧客情報を取得
      const stripeCustomerInfo = await this.fetchStripeCustomerInfo();
      if (stripeCustomerInfo === false) {
        return false;
      }
      // Stripe顧客情報詳細がない場合はStripe顧客情報を新規作成
      if (!stripeCustomerInfo) return await this.createStripeCustomer();

      // 登録済みカード情報取得
      this.setCardNumberLast4(stripeCustomerInfo);

      return true;
    },

    async createStripeCustomer() {
      const createCustomerParams = {
        uid: this.user_info.uid,
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,
      };

      const createCustomerResponse = await this.apiCall('stripe/customer', createCustomerParams, 'post');
      if (!createCustomerResponse || !createCustomerResponse.stripe_customer_id) return false;
      this.newStripeCustomerId = createCustomerResponse.stripe_customer_id;

      this.stripeForm = true;
      this.stripeInfo = false;
      return true;
    },

    async fetchStripeCustomerInfo() {
      const retrieveCustomerParams = {
        stripe_customer_id: this.user_info.stripe_customer_id,
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,
      };

      const retrieveCustomerResponse = await this.apiCall('stripe/customer/retrieve', retrieveCustomerParams, 'post');
      if (!retrieveCustomerResponse) {
        return false;
      }

      return retrieveCustomerResponse.customer ?? null;
    },

    setCardNumberLast4(stripeCustomerInfo) {
      if (!stripeCustomerInfo) {
        this.cardNumberLast4 = '****';
        this.stripeForm = true;
        this.stripeInfo = false;
        return;
      }

      // デフォルトカード情報取得
      const defaultCard = stripeCustomerInfo?.invoice_settings?.default_payment_method || null;
      this.defaultPaymentMethodId = defaultCard?.id || null;
      if (this.defaultPaymentMethodId !== null) {
        this.cardNumberLast4 = defaultCard.card.last4;
        this.stripeForm = false;
        this.stripeInfo = true;
        this.stripe_customer_info = stripeCustomerInfo;
        this.stripe_customer_id = this.user_info.stripe_customer_id;
      } else {
        this.cardNumberLast4 = '****';
        this.stripeForm = true;
        this.stripeInfo = false;
      }
    },

    async preparationIntent() {
      const ticketType = this.getTicketType(this.item);
      this.ticketType = ticketType;
      let createType;
      let res;
      switch (ticketType) {
        case 'lottery':
          res = await this.createSetupIntent();
          createType = 'SetupIntent';
          break;
        case 'normal':
          res = await this.createPaymentIntent();
          createType = 'PaymentIntent';
          break;
        case 'subscription':
          res = await this.createSubscription();
          createType = 'Subscription';
          break;
        default:
          console.error('unknown ticketType:', ticketType);
          return false;
      }
      if (!res) {
        console.error('Stripeエラー', createType + 'の作成に失敗しました。');
        this.callDialog('Stripeエラー', '支払い準備に失敗しました。', 3);
        return false;
      }

      switch (ticketType) {
        case 'lottery':
          this.clientSecret = res.client_secret;
          this.stripe_id = res.setup_intent_id;
          break;
        case 'normal':
          this.clientSecret = res.client_secret;
          this.stripe_id = res.payment_intent_id;
          break;
        case 'subscription':
          this.clientSecret = res.client_secret;
          this.stripe_id = res.subscription_id;
          break;
        default:
          console.error('unknown ticketType:', ticketType);
          return false;
      }
      return true;
    },

    //抽選
    async createSetupIntent () {
      const requestParams = {
        uid: this.user_info.uid,
        user_id: String(this.user_info.id),
        order_type: 0,                    // 0: デジチケ, 1: モバイルペイ
        order_id: String(this.item.id),
        payment_type: 0,
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,                // 0:uplink, 1:外部アプリ
      };
      if (this.user_info.stripe_customer_id != null && this.stripe_customer_info != null) {
        // userInfoのstripe_customer_idからStripe顧客情報が取得出来た場合
        requestParams.stripe_customer_id = this.user_info.stripe_customer_id;
      } else {
        // 新規作成したstripe顧客IDをセット
        requestParams.stripe_customer_id = this.newStripeCustomerId;
      }

      const response = await this.apiCall('stripe/setup-intent', requestParams, 'post');
      if (!response || !response.client_secret || !response.setup_intent_id) return false;
      return response;
    },

    //決済
    async createPaymentIntent () {
      const requestParams = {
        uid: this.user_info.uid,
        user_id: String(this.user_info.id),
        order_type: 0,                        // 0: デジチケ, 1: モバイルペイ
        order_id: String(this.item.id),
        amount: this.item.amount,
        tax_rate: this.item.tax_rate,
        currency: 'jpy',
        description: this.item.title,         // 旧サービス同様titleを使用
        payment_type: 0,
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,                    // 0:uplink, 1:外部アプリ
      };
      if (this.user_info.stripe_customer_id != null && this.stripe_customer_info != null) {
        // userInfoのstripe_customer_idからStripe顧客情報が取得出来た場合
        requestParams.stripe_customer_id = this.user_info.stripe_customer_id;
      } else {
        // 新規作成したstripe顧客IDをセット
        requestParams.stripe_customer_id = this.newStripeCustomerId;
      }

      const response = await this.apiCall('stripe/payment-intent', requestParams, 'post');
      if (!response || !response.client_secret || !response.payment_intent_id) return false;
      return response;
    },

    //定期購読決済
    async createSubscription () {
      const requestParams = {
        uid: this.user_info.uid,
        user_id: String(this.user_info.id),
        order_type: 0,                        // 0: デジチケ, 1: モバイルペイ
        order_id: String(this.item.id),
        payment_type: 0,
        name: this.item.title,
        type: 'service',
        interval: this.item.interval,
        interval_count: this.item.subscription_range,
        nickname: this.item.title,
        amount: this.item.amount,
        tax_rate: this.item.tax_rate,
        currency: 'jpy',
        usage_type: 'licensed',
        description: this.item.title,         // 旧サービス同様titleを使用
        payment_shop_id: String(this.customer_shop_id),
        cooperate_type: 0,                    // 0:uplink, 1:外部アプリ
      };
      if (this.user_info.stripe_customer_id != null && this.stripe_customer_info != null) {
        // userInfoのstripe_customer_idからStripe顧客情報が取得出来た場合
        requestParams.stripe_customer_id = this.user_info.stripe_customer_id;
      } else {
        // 新規作成したstripe顧客IDをセット
        requestParams.stripe_customer_id = this.newStripeCustomerId;
      }

      const response = await this.apiCall('stripe/subscription/incompleted', requestParams, 'post');
      if (!response || !response.client_secret || !response.subscription_id) return false;
      return response;
    },

    getTicketType(digitalTicket) {
      if (digitalTicket.limit_type === 2) {
        // 抽選
        return 'lottery';
      } else if (digitalTicket.ticket_type === 1 || digitalTicket.ticket_type === 2 || (digitalTicket.ticket_type === 3 && digitalTicket.subscription_type === 2)) {
        // 通常
        return 'normal';
      } else if (digitalTicket.ticket_type === 3 && digitalTicket.subscription_type === 1) {
        // 定期購読
        return 'subscription';
      }
      // その他
      return 'unknown';
    },
  },

  async created() {
    this.getUrlParam()
    this.init = this.storageGet('*')

    try{
      // デジタルチケット詳細取得
      if (!await this.fetchDigitalTicket()) return;
      // ユーザ情報取得
      if (!await this.fetchUserInfo()) return;

      // Stripe顧客情報取得またはStripe顧客情報作成
      if (!await this.fetchOrCreateStripeCustomer()) return;

      if (!await this.preparationIntent()) return;

      // Stripe準備
      await this.makeStripe(this.item);

      // カード入力フォームの準備
      if (this.stripeForm && !this.stripeInfo) {
        await this.makeStripeForm();
      }
    } catch(e) {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
        console.log(e)
    }
  }
  //NEW_DEV-2159 cyber end

};
</script>

<style scoped>
.lh {
  line-height: 26px;
}
.bordered {
  border: 1px solid #000 !important;
}
.balloon1 {
  position: relative;
  display: block;
  margin: 1.5em auto;
  padding: 2px 20px;
  min-width: 120px;
  max-width: 100%;
  width: 60%;
  font-size: 14px;
  color: #fff;
  background: #35D4CA;
  border-radius: 20px;
}
.balloon1.sub {
  background: #9DD435;
}

.balloon1:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -10px;
  border: 10px solid transparent;
  border-top: 10px solid #35D4CA;
}

.balloon1.sub:before {
  border-top: 10px solid #9DD435;
}

.balloon1 p {
  margin: 0;
  padding: 0;
  text-align: center;
}



.titlebar {
  background-color: #E4E4E4;
  padding: 5px 20px;
  font-size: 14px;
  color: #333333;
  margin-bottom: 15px;
}

.tickettitle {
  font-size: 20px;
}

.checkboxstyle {
  font-size: 11px !important;
}
.footinfo {
  background-color: #595757;
  color: #fff;
}

/* Apple Pay UI FROM */
.apple-pay-button-with-text {
  display: inline-block;
    background-size: 100% 60%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border-radius: 60px;
    box-sizing: border-box;
    width: 70%;
    min-height: 32px;
    max-height: 64px;
    background-image: -webkit-named-image(apple-pay-logo-white);
    margin-left: 15%;
    text-decoration: none;
    font-size: 1.5rem;
    line-height: 1.4;
    outline: 0;
    border: 0px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0,0,0,0.3);
}

.apple-pay-button-with-buy {
  -apple-pay-button-type: buy;
}

.apple-pay-button-with-setup {
  -apple-pay-button-type: set-up;
}

.apple-pay-button-with-text > * {
    /*display: none;*/
}

.hidden {
  display:none;
}
.entry_dialogue_title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 0 0 15px;
}
.entry_dialogue_text {
    font-size: 13px;
    line-height: 20px;
    color: #333333;
}

/* Apple Pay UI TO */

.dl-ticket-kessai dt {
  font-size: 13px;
  color: rgb(157, 157, 157);
  font-weight: 700 !important;
}
#card-number-element, #card-expiry-element, #card-cvc-element {
  border-style: solid;
  border-width: 0 0 thin 0;
  border-color: rgba(0, 0, 0, 0.42);
  margin-bottom: 40px;
}
.checkfont >>> label {
  font-size: 11px;
}
</style>
